// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"ffbf5a6d","498":"20efc46e","545":"6e1610b2","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};